import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { ErrorBoundary } from ":shared/ui/error-boundary/error-boundary";
import { PageSkeleton } from ":shared/ui/skeleton";
import { Suspense } from "react";
import { isRTL } from ":shared/lib/i18n";
import "../globals.css";
import ":shared/lib/i18n/config";

export interface RouterContext {
	queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootComponent,
	beforeLoad: ({ location }) => {
		const pathParts = location.pathname.split("/").filter(Boolean);
		const locale = pathParts[0] || "en";

		if (typeof document !== "undefined") {
			document.documentElement.lang = locale;
			document.documentElement.dir = isRTL(locale) ? "rtl" : "ltr";
		}
	},
});

function RootComponent() {
	return (
		<ErrorBoundary
			onError={(error, errorInfo) => {
				console.error("Root ErrorBoundary caught:", error, errorInfo);
			}}
		>
			<Suspense fallback={<PageSkeleton />}>
				<Outlet />
			</Suspense>
			{import.meta.env.DEV && (
				<TanStackRouterDevtools position="bottom-right" />
			)}
		</ErrorBoundary>
	);
}
